import React, { useEffect, useState } from "react";
import { BsLink45Deg, BsFillCheckCircleFill } from "react-icons/bs";
import { Tooltip } from "antd";
import { isNavigable } from "../../Utils/StayUpToDate/RenderComponent";
import { GrFormEdit } from "react-icons/gr";
import { getPublicUrl } from "../../Utils/CustomDomain/CustomDomainFuntions";

const CopyComponent = (props: any) => {
  const {
    username,
    user_id,
    component,
    buttonText = "Copy Link",
    description = "Click to copy the link for this item",
    from,
    onRouteEdit // NEW: Callback function from parent
  } = props;
  
  const [copied, setCopied] = useState(false);
  const [route, setRoute] = useState(component.route_name || "");

  useEffect(() => {
    setRoute(component.route_name || component.unique_id || "")
  }, [component])

  // Function to handle the copy action
  const copyToClipboard = () => {
    const url = getPublicUrl(username, route); 
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy URL: ", err);
      });
  };

  const openRouteModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Call the parent's callback instead of handling modal here
    if (onRouteEdit) {
      onRouteEdit();
    }
  };

  // Check if the component is navigable
  const canNavigate = isNavigable(component);

  if (!canNavigate) {
    return null;
  }

  return (
    <Tooltip
      placement="bottom"
      open={copied}
      title={
        copied ? (
          <div className="tooltip-style">
            <BsFillCheckCircleFill />
            <p className="m-0">Copied!</p>
          </div>
        ) : (
          <p className="m-0">{description}</p>
        )
      }
    >
      <div
        className="copy-clipboard-btn-wrapper"
        id="copy-link"
        style={{
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <span onClick={copyToClipboard} style={{ display: 'flex', alignItems: 'center' }}>
          <BsLink45Deg size={18} />
        </span>
        <span style={{ margin: '0 4px' }}>|</span>
        <span onClick={openRouteModal} style={{ display: 'flex', alignItems: 'center' }}>
          <GrFormEdit size={18} />
        </span>
      </div>
    </Tooltip>
  );
};

export default CopyComponent;